import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core';
import * as logger from '../../../logger';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { InvoiceAddPaymentSideBarCss } from './InvoiceSideBarCss';
import { updateChatView } from "../../../store/actions/userActionCreators";
import { addSinglePartyPayment } from "../../../store/actions/partiesActionCreator";
import { Form } from 'react-final-form';
import {
    TextField,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches,
    Checkboxes
} from 'mui-rff';
import {
    PAYMENT_METHODS_LIST
} from "../../../store/constants";
import TextInputState from '../Inputs/TextInputState';
import DateFnsUtils from '@date-io/date-fns';
import { replaceCommas, numberWithCommas, numberFormat, findArrayObjectIndex, getVehicleNumberValuesDWeb, getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';
import AmountInput from '../Inputs/AmountInput';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';


const InvoiceAddPaymentSideBar = ({
    open,
    onClose,
    onConfirm,
    user,
    trip,
    sideBarName,
    dispatchChatView,
    dispatchTripDetailsAction,
    dispatchGetSingleInvoice,
    dispatchAddPartyPayment
}) => {

    let submit, tripSubmit, tripEditSubmit;

    const classes = InvoiceAddPaymentSideBarCss();

    const [dialogOpen, setDialogOpen] = useState(open);
    const [sideBarTitle, setSideBarTitle] = useState("Add Payment");

    const [amountValue, setAmountValue] = useState("");
    const [paymentMethodValue, setPaymentMethodValue] = useState("Cash");
    const [refNumberValue, setRefNumberValue] = useState("");
    const [paymentDateValue, setPaymentDateValue] = useState(new Date());
    const [notesValue, setNotesValue] = useState("");

    const [invoiceAmount, setInvoiceAmount] = useState("");
    const [partyDetails, setPartyDetails] = useState({});

    const [checkedTrips, setCheckedTrips] = useState([]);
    const [trips, setTrips] = React.useState([]);
    const [designCheck, setDesignCheck] = useState(false);
    const [tripsError, setTripsError] = useState(false);
    const [remainingAmount, setRemainingAmount] = useState(0);
    const [tripKey, setTripKey] = React.useState(null);
    const [selectedForEdit, setSelectedForEdit] = React.useState(null);
    const [selectedAmount, setSelectedAmount] = React.useState(0);
    const [tripAmountEditOpen, setTripAmountEditOpen] = React.useState(false);
    const [dialogConfirmDisabled, setDialogConfirmDisabled] = useState(false);
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [allocatedText, setAllocatedText] = useState("");
    const [fullyAllocated, setFullyAllocated] = useState(false);
    const [confirmDisabled, setConfirmDisabled] = useState(false);
    const [tripChangeDetected, setTripChangeDetected] = useState(false);

    const initialValues = {
        amount: amountValue ? numberWithCommas(amountValue) : "",
        paymentMethod: paymentMethodValue ? paymentMethodValue : "Cash",
        refNumber: refNumberValue ? refNumberValue : "",
        paymentDate: paymentDateValue ? paymentDateValue : new Date(),
        notes: notesValue ? notesValue : ""
    }

    const initialTripAmountValues = {
        amount: selectedAmount ? numberWithCommas(selectedAmount) : ""
    }

    const initialTripValues = {
        trips: trips,
    }


    useEffect(() => {

        dispatchChatView(false);

        if (trip && trip.singleInvoiceInfo) {

            if (trip.singleInvoiceInfo.amounts && trip.singleInvoiceInfo.amounts.balance) {
                setInvoiceAmount(trip.singleInvoiceInfo.amounts.balance);
                setAmountValue(trip.singleInvoiceInfo.amounts.balance);
            }

            if (trip.singleInvoiceInfo.customerGSTDetails) {
                setPartyDetails(trip.singleInvoiceInfo.customerGSTDetails);
            }

            if (trip.singleInvoiceInfo.invoiceDetails) {
                setInvoiceDetails(trip.singleInvoiceInfo.invoiceDetails)
            }

            if (trip.singleInvoiceInfo.trips) {
                setCheckedTrips(trip.singleInvoiceInfo.trips)
            }

        }

    }, [open]);

    useEffect(() => {

        setTimeout(() => {
            if (checkedTrips && checkedTrips.length > 0) {

                for (var i = 0; i < checkedTrips.length; i++) {

                    if (trips.includes(checkedTrips[i].id)) {

                        if (Number(checkedTrips[i].attributionAmount) == Number(checkedTrips[i] && checkedTrips[i].amounts && checkedTrips[i].amounts.balance ? checkedTrips[i].amounts.balance : "")) {

                            if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #0033cc';
                            }

                            if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #0033cc !important'
                            }

                        } else
                            if (Number(checkedTrips[i].attributionAmount) < Number(checkedTrips[i] && checkedTrips[i].amounts && checkedTrips[i].amounts.balance ? checkedTrips[i].amounts.balance : "")) {
                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].style.border = 'solid 1px #e8843c';
                                }
                                if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0]) {
                                    document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked')[0].style = 'color: #e8843c !important'
                                }
                            }
                    } else {
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].style = 'border: none !important';
                        }
                        if (document.getElementsByClassName('form-group-checkbox') && document.getElementsByClassName('form-group-checkbox')[0] && document.getElementsByClassName('form-group-checkbox')[0].children[i] && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('Mui-checked') && document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0]) {
                            document.getElementsByClassName('form-group-checkbox')[0].children[i].getElementsByClassName('MuiIconButton-colorSecondary')[0].removeAttribute("style");
                        }
                    }
                }

            }
        }, 90)


    }, [checkedTrips, trips, designCheck, sideBarTitle]);


    // ******************************************** Add Payment Side Bar Screen. ********************************************

    const validate = values => {

        const errors = {};

        if (values && !values.amount) {
            errors.amount = "Please enter amount.";
        }

        if (values && values.amount && invoiceAmount && Number(replaceCommas(invoiceAmount)) < Number(replaceCommas(values.amount))) {
            errors.amount = "Amount cannot be greater than" + " " + numberFormat(invoiceAmount ? invoiceAmount : 0)
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;

    }

    const getFormFields = (values) => {
        let paymentMode = values.paymentMethod;
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.formTitle}>Amount Received*</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setAmountValue(e.target.value);
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3} >
                        <div className={classes.formTitle}>Payment Method</div>
                        <Select
                            name="paymentMethod"
                            variant="outlined"
                            placeholder={'Select Payment Method'}
                            onChange={(e) => { setPaymentMethodValue(e.target.value) }}
                            formControlProps={{ margin: 'none', size: "small" }}
                            required={true}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV2 }}
                        >
                            {PAYMENT_METHODS_LIST && PAYMENT_METHODS_LIST.map((type) => {
                                return (<MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>);
                            })}
                        </Select>
                    </div>
                ),
            },
            {
                size: 12,
                visible: ['Cheque', 'UPI', 'Bank Transfer'].includes(paymentMode),
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>{(paymentMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}</div>
                        <TextInputState
                            placeholder={"Enter the " + (paymentMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
                            name="refNumber"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setRefNumberValue(e.target.value) }}
                            margin="normal"
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>Payment Date</div>
                        <DatePicker
                            disableFuture
                            name="paymentDate"
                            margin="normal"
                            variant="inline"
                            inputVariant="outlined"
                            size="small"
                            onChange={(date) => { setPaymentDateValue(date) }}
                            format="dd-MM-yyyy"
                            placeholder="Enter a Date"
                            required={true}
                            dateFunsUtils={DateFnsUtils}
                            className={classes.mtV2}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.mtV3}>
                        <div className={classes.formTitle}>Notes</div>
                        <TextInputState
                            placeholder="Enter Notes"
                            name="notes"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            onChange={(e) => { setNotesValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            },
        ]
    }

    const onSubmit = values => {


        let remainingAmountValue = Number(replaceCommas(amountValue));

        if (remainingAmountValue == invoiceAmount) {

            const paymentDetails = {
                amount: invoiceAmount ? replaceCommas(invoiceAmount) : "",
                paymentMode: paymentMethodValue ? paymentMethodValue : "",
                isAdvance: false,
                paymentData: refNumberValue ? refNumberValue : "",
                customerId: Number(invoiceDetails && invoiceDetails.customerId ? invoiceDetails.customerId : ""),
                description: notesValue ? notesValue : "",
                paymentDate: paymentDateValue ? Math.round((paymentDateValue.setHours(0, 0, 0, 0) / 1000)) : "",
            }

            if (checkedTrips && checkedTrips.length > 0) {
                const tripList = []
                checkedTrips.map((tripData) => {
                    tripList.push({
                        tripId: tripData && tripData.id ? tripData.id : "",
                        attributionAmount: tripData && tripData.amounts && tripData.amounts.balance ? Number(tripData.amounts.balance) : ""
                    })
                });
                paymentDetails.tripsAttributed = tripList;
            }

            dispatchAddPartyPayment(paymentDetails,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Invoice Add Payment Dweb', 'Add vendor payment Sucsessfull');
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                (data) => {
                    logger.log('Invoice Add Payment Dweb', 'Add vendor payment Failed');
                }
            )

        } else {
            setSideBarTitle("Choose Trips");
        }


        // ************************************** Formatting trips attribution amount based on amount entered by user. **************************************
        for (let i = 0; i < checkedTrips.length; i++) {

            const tripBalance = checkedTrips && checkedTrips[i] && checkedTrips[i].amounts && checkedTrips[i].amounts.balance ? Number(checkedTrips[i].amounts.balance) : 0;

            if ((Number((remainingAmountValue)) - tripBalance) > 0) {
                checkedTrips[i].attributionAmount = tripBalance
                remainingAmountValue = Number((remainingAmountValue)) - tripBalance;
                trips.push(checkedTrips[i].id);
            } else if ((Number((remainingAmountValue)) - tripBalance) == 0) {
                checkedTrips[i].attributionAmount = tripBalance
                remainingAmountValue = 0;
                trips.push(checkedTrips[i].id);
            } else if ((Number((remainingAmountValue)) - tripBalance) < 0) {
                if (remainingAmountValue == 0) {
                    checkedTrips[i].attributionAmount = 0;
                } else if (remainingAmountValue > 0) {
                    checkedTrips[i].attributionAmount = remainingAmountValue;
                    remainingAmountValue = 0;
                    trips.push(checkedTrips[i].id);
                }
            }

        }

    }

    // **************************************** Choose Trips Screen. ****************************************
    const getTripFormFields = (values) => {

        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV5}>
                            {tripsError && tripChangeDetected &&
                                <div className={classes.errorV1}>Please select a trip</div>
                            }
                            <div className={classes.checkBoxLabel}>Select Trips</div>
                            <Checkboxes
                                name="trips"
                                onChange={(e) => {

                                    let values = [...trips];

                                    setTripChangeDetected(true);

                                    if (values.includes(Number(e.target.value))) {
                                        values = values.filter(function (value, index, arr) {
                                            return value != Number(e.target.value);
                                        });
                                    } else {
                                        values.push(Number(e.target.value));

                                        let selected = [...checkedTrips];
                                        let index = findArrayObjectIndex('id', Number(e.target.value), selected);

                                        const tripBalance = Number(selected[index] && selected[index].amounts && selected[index].amounts.balance ? selected[index].amounts.balance : 0);

                                        if (remainingAmount <= tripBalance) {
                                            selected[index].attributionAmount = remainingAmount;
                                        } else if (remainingAmount > tripBalance) {
                                            selected[index].attributionAmount = tripBalance;
                                        }

                                        setCheckedTrips(selected);

                                    }
                                    setTrips([...new Set(values)])
                                    setDesignCheck(!designCheck);
                                }}
                                formControlProps={{
                                    margin: 'none',
                                    className: classes.checkboxInput
                                }}
                                formControlLabelProps={{
                                    className: classes.checkboxTripLabel
                                }}
                                formLabelProps={{
                                    className: classes.checkBoxLabel
                                }}
                                formGroupProps={{
                                    className: 'form-group-checkbox'
                                }}
                                classes={{ checked: classes.checkBoxChecked }}
                                data={getTripsSelection(values)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const getTripsSelection = (values) => {
        let trips = [];
        if (checkedTrips && Array.isArray(checkedTrips)) {
            for (const key in checkedTrips) {
                if (Object.hasOwnProperty.call(checkedTrips, key)) {
                    const tripData = checkedTrips[key];
                    tripData.value = tripData.id;
                    tripData.label = (
                        <div className={classes.mlV1} >
                            <Grid container wrap="nowrap" justify="space-between" >
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidthV1 }}>
                                    <Grid item className={classes.gridRoute}>
                                        <span>{tripData && tripData.sourceLocation ? tripData.sourceLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</span>
                                    </Grid>
                                    <Grid item className={classes.gridParam}>

                                        <div>{tripData && tripData.startDate ? getMilliDatePickerDateInStringDDMMMYYYY(tripData.startDate) : ""}</div>
                                        <FiberManualRecordIcon className={classes.dotV1} />
                                        <div className={classes.divAlignV2}>
                                            {tripData && tripData.truckNumber ?
                                                (
                                                    getVehicleNumberValuesDWeb(tripData.truckNumber).map((vehicleNumber, index) => (
                                                        <div className={index != 0 ? classes.mlV2 : ""}>
                                                            {vehicleNumber}
                                                        </div>
                                                    ))
                                                )
                                                :
                                                ""}
                                        </div>

                                    </Grid>
                                </Grid>
                                <Grid container wrap="nowrap" direction="column" classes={{ container: classes.containerWidth }}>
                                    {values && values.trips && !values.trips.includes(tripData.id) &&
                                        <Grid item className={classes.tripBalance} >
                                            {tripData && tripData.amounts && tripData.amounts.balance ? numberFormat(tripData.amounts.balance) : ""}
                                        </Grid>
                                    }
                                    {values && values.trips && values.trips.includes(tripData.id) &&
                                        <>
                                            <Grid container wrap="nowrap" alignItems="center" classes={{ container: classes.containerWidth }} >
                                                <Grid item className={classes.gridItemV1} >
                                                    <TextField
                                                        name={'attributionAmount-' + tripData.id}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth={false}
                                                        value={tripData.attributionAmount ? numberFormat(tripData.attributionAmount) : 0}
                                                        margin="none"
                                                        onClick={(e) => {
                                                            handleTripAmountClick(e, key)
                                                        }}
                                                        className={classes.cardInput}
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <div className={Number(tripData.attributionAmount) < Number(tripData && tripData.amounts && tripData.amounts.balance ? tripData.amounts.balance : 0) ? classes.divAlignV1 : classes.divAlign} >
                                                        <div className={classes.marginV1} >/</div>
                                                        <div>{tripData && tripData.amounts && tripData.amounts.balance ? numberFormat(tripData.amounts.balance) : ""}</div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <Grid item className={classes.gridItemStatus} >
                                                {Number(tripData.attributionAmount) == Number(tripData && tripData.amounts && tripData.amounts.balance ? tripData.amounts.balance : "") &&
                                                    <div className={classes.divBox}>
                                                        Full Payment
                                                    </div>
                                                }
                                                {Number(tripData.attributionAmount) < Number(tripData && tripData.amounts && tripData.amounts.balance ? tripData.amounts.balance : "") &&
                                                    <div className={classes.divBoxPart}>
                                                        Part Payment
                                                    </div>
                                                }
                                            </Grid>
                                        </>
                                    }

                                </Grid>
                            </Grid>
                        </div >
                    )

                    trips.push(tripData);
                }

            }
        }

        return trips;
    }

    const onTripSubmit = values => {

        if (tripsError) {
            return;
        } else {
            const paymentDetails = {
                amount: amountValue ? replaceCommas(amountValue) : "",
                paymentMode: paymentMethodValue ? paymentMethodValue : "",
                isAdvance: false,
                paymentData: refNumberValue ? refNumberValue : "",
                customerId: Number(invoiceDetails && invoiceDetails.customerId ? invoiceDetails.customerId : ""),
                description: notesValue ? notesValue : "",
                paymentDate: paymentDateValue ? Math.round((paymentDateValue.setHours(0, 0, 0, 0) / 1000)) : "",
            }

            if (trips && trips.length > 0) {
                const tripList = []
                trips.map((tripData) => {
                    const filteredData = checkedTrips.filter((tripListData) => tripListData.id == tripData);
                    if (filteredData && filteredData[0] && filteredData[0].attributionAmount != 0) {
                        tripList.push({
                            tripId: filteredData && filteredData[0] && filteredData[0].id ? filteredData[0].id : "",
                            attributionAmount: filteredData && filteredData[0] && filteredData[0].attributionAmount ? Number(filteredData[0].attributionAmount) : ""
                        })
                    }
                });
                paymentDetails.tripsAttributed = tripList;
            }

            dispatchAddPartyPayment(paymentDetails,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Invoice Add Payment Dweb', 'Add vendor payment Sucsessfull');
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                (data) => {
                    logger.log('Invoice Add Payment Dweb', 'Add vendor payment Failed');
                }
            )
        }

    }

    const tripValidate = values => {

        let errors = [];

        if (values && values.trips && values.trips.length == 0) {
            setTripsError(true);
        } else {
            setTripsError(false);
        }

        let allocatedAmount = 0;
        let amountValueEntered = Number(replaceCommas(amountValue));

        for (var i = 0; i < values.trips.length; i++) {

            let filteredTrip = checkedTrips.filter((tripData) => tripData.id == (values && values.trips[i] ? values.trips[i] : ""))
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }

        if (allocatedAmount == amountValueEntered) {
            setAllocatedText(numberFormat(amountValueEntered));
            setRemainingAmount(0);
            setFullyAllocated(true);
        } else if (allocatedAmount < amountValueEntered) {
            setAllocatedText(numberFormat(amountValueEntered - allocatedAmount));
            setFullyAllocated(false);
            setRemainingAmount(replaceCommas(amountValueEntered - allocatedAmount));
        }

        return errors;
    }

    // ******************************************** Edit Amount Dialog Actions and Functions. ********************************************
    const handleTripAmountClick = (e, key) => {
        if (checkedTrips) {
            setTripKey(key);
            setSelectedForEdit(checkedTrips[key]);
            setSelectedAmount(checkedTrips && checkedTrips[key] && checkedTrips[key].attributionAmount ? checkedTrips[key].attributionAmount : 0)
            setTripAmountEditOpen(true);
        }
    }

    const handleEditAmountClose = () => {
        setTripKey(null);
        setSelectedForEdit(null);
        setSelectedAmount(null);
        setTripAmountEditOpen(false);
    }

    const onTripEditSubmit = values => {
        if (Object.keys(editAmountValidate(initialTripAmountValues)).length == 0) {
            let values = [...checkedTrips];
            values[tripKey].attributionAmount = replaceCommas(selectedAmount);
            setCheckedTrips(values);
            setTripKey(null);
            setSelectedForEdit(null);
            setSelectedAmount(null);
            setTripAmountEditOpen(false);
        }
    }

    const getAmountFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divAmountContainer} >
                        <div className={classes.titleV3}>Amount</div>
                        <AmountInput
                            placeholder="Enter Amount"
                            name="amount"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            onChange={(e) => {
                                setSelectedAmount(e.target.value)
                            }}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
                            }}
                            className={classes.mtV4}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                ),
            }
        ]
    }

    const editAmountValidate = values => {
        const errors = {};
        let allocatedAmount = 0;

        let ignoreTripId = checkedTrips && checkedTrips[tripKey] && checkedTrips[tripKey].id ? checkedTrips[tripKey].id : "";

        for (var i = 0; i < trips.length; i++) {
            let filteredTrip = checkedTrips.filter((tripData) => {
                return tripData.id == (trips[i] ? trips[i] : "") && tripData.id != ignoreTripId
            })
            allocatedAmount += filteredTrip && filteredTrip[0] && filteredTrip[0].attributionAmount ? Number(filteredTrip[0].attributionAmount) : 0
        }

        if (!values.amount) {
            errors.amount = "Please enter amount"
        }

        if (values && values.amount && Number(replaceCommas(values.amount)) > (Number(replaceCommas(amountValue)) - Number(allocatedAmount ? replaceCommas(allocatedAmount) : 0))) {
            errors.amount = "Amount cannot be greater than " + numberFormat(Number(replaceCommas(amountValue)) - Number(allocatedAmount ? replaceCommas(allocatedAmount) : 0))
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setDialogConfirmDisabled(true);
        } else {
            setDialogConfirmDisabled(false);
        }

        return errors;
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const handleBackClick = () => {
        setTripChangeDetected(false);
        setSideBarTitle("Add Payment");
        setTrips([]);
    }

    return (
        <>

            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: sideBarTitle == "Add Payment" ? classes.transactionDetailsDrawer : classes.transactionDetailsDrawerChooseTrips
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        {sideBarTitle == "Add Payment" &&
                            <>
                                Add Payment
                            </>
                        }
                        {sideBarTitle == "Choose Trips" &&
                            <>
                                Choose Trips
                            </>
                        }
                    </div>
                </SideBarDialogTitle>

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >
                    <Grid container justify="space-between" wrap="nowrap" className={classes.gridContainer}>
                        <Grid container direction="column">
                            <Grid item className={classes.titleV1} >
                                Party
                            </Grid>
                            <Grid item className={classes.textV1} >
                                {partyDetails && partyDetails.companyName ? partyDetails.companyName : ""}
                            </Grid>
                        </Grid>
                        <Grid container direction="column">
                            <Grid item className={classes.titleV2}>
                                {sideBarTitle == "Add Payment" &&
                                    <>
                                        Invoice Balance
                                    </>
                                }
                                {sideBarTitle == "Choose Trips" &&
                                    <>
                                        Payment Amount
                                    </>
                                }
                            </Grid>
                            <Grid item className={classes.textV2}>
                                {sideBarTitle == "Add Payment" &&
                                    <>
                                        {numberFormat(invoiceAmount ? invoiceAmount : 0)}
                                    </>
                                }
                                {sideBarTitle == "Choose Trips" &&
                                    <>
                                        {amountValue ? numberFormat(replaceCommas(amountValue)) : numberFormat(0)}
                                    </>
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    {sideBarTitle == "Add Payment" &&
                        <div className={classes.mtV1} >
                            <Form
                                onSubmit={onSubmit}
                                initialValues={initialValues}
                                validate={validate}
                                render={({ handleSubmit, form, submitting, pristine, values }) => {
                                    submit = handleSubmit
                                    return (
                                        <form onSubmit={handleSubmit} noValidate>
                                            <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                                {getFormFields(values).map((item, idx) => item.visible ? (
                                                    <Grid item xs={item.size} key={idx}>
                                                        {item.field}
                                                    </Grid>
                                                ) : null)}
                                            </Grid>
                                        </form>
                                    )
                                }}
                            />
                        </div>
                    }

                    {sideBarTitle == "Choose Trips" &&
                        <div>
                            <Form
                                onSubmit={onTripSubmit}
                                initialValues={initialTripValues}
                                validate={tripValidate}
                                render={({ handleSubmit, form, submitting, pristine, values }) => {
                                    tripSubmit = handleSubmit; return (
                                        <form onSubmit={handleSubmit} noValidate>
                                            <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                                {getTripFormFields(values).map((item, idx) => item.visible ? (
                                                    <Grid item xs={item.size} key={idx}>
                                                        {item.field}
                                                    </Grid>
                                                ) : null)}
                                            </Grid>
                                        </form>
                                    )
                                }}
                            />
                        </div>
                    }

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions}>
                    {sideBarTitle == "Choose Trips" &&
                        <div className={fullyAllocated ? classes.paymentFullyAllocated : classes.paymentPartiallyAllocated}>
                            {fullyAllocated &&
                                <>
                                    <CheckCircleIcon className={classes.doneV1} />
                                    <div className={classes.divAlignV5}><div className={classes.fw300}>{allocatedText}&nbsp;</div> <div>has been fully allocated.</div></div>
                                </>
                            }
                            {!fullyAllocated &&
                                <>
                                    <ErrorIcon className={classes.errorV2} />
                                    <div className={classes.divAlignV5}><div className={classes.fw300}>{allocatedText}&nbsp;</div> <div>has not been allocated yet.</div></div>
                                </>
                            }
                        </div>
                    }
                    <div className={classes.divAlignActions}>
                        {sideBarTitle == "Add Payment" &&
                            <>
                                <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                                    Close
                                </Button>

                                <Button variant="contained" className={classes.chooseTripsButton} disabled={confirmDisabled} classes={{ disabled: classes.chooseTripsButtonDisabled }} onClick={(event) => submit(event)}>
                                    {Number(replaceCommas(amountValue)) == Number(replaceCommas(invoiceAmount)) ?
                                        <>
                                            Confirm
                                        </>
                                        :
                                        <>
                                            Choose Trips
                                        </>
                                    }
                                </Button>
                            </>
                        }
                        {sideBarTitle == "Choose Trips" &&
                            <>
                                <Button variant="contained" className={classes.cancelButton} onClick={() => handleBackClick()}>
                                    Back
                                </Button>
                                <Button variant="contained" className={classes.chooseTripsButton} disabled={tripsError} classes={{ disabled: classes.chooseTripsButtonDisabled }} onClick={(event) => onTripSubmit(event)}>
                                    Confirm
                                </Button>
                            </>
                        }
                    </div>
                </SideBarDialogActions>

            </Drawer>

            {/* ******************************** Dialog to edit trip amount (trip attribution amount.) ******************************** */}
            {tripAmountEditOpen &&
                <Dialog fullWidth={true} maxWidth='xs' onClose={handleEditAmountClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="trip-amount-edit-dialog-title" open={tripAmountEditOpen} className={classes.dialogV1} classes={{ paperWidthXs: classes.widthV1 }} >
                    <DialogTitle id="trip-amount-edit-dialog-title" className={classes.dialogTitleV1}>
                        <div className={classes.divAlignTitle} >
                            <div className={classes.divTitle} >
                                Enter Amount
                            </div>
                            <div>
                                <IconButton onClick={handleEditAmountClose}>
                                    <CloseIcon className={classes.closeIconV1} />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent dividers className={classes.dialogContentV1}>

                        <Grid container direction="column">

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridTitleDialog}>
                                <Grid item>
                                    Trip Details
                                </Grid>
                                <Grid item>
                                    Balance
                                </Grid>
                            </Grid>

                            <Grid container direction="row" justify="space-between" alignItems="center" wrap="nowrap" className={classes.gridContainerDialog}>

                                <Grid container direction="column" wrap="nowrap" classes={{ container: classes.containerWidth }}>
                                    <Grid item className={classes.gridRouteDialog}>
                                        <span>{selectedForEdit && selectedForEdit.sourceLocation ? selectedForEdit.sourceLocation : ""}&nbsp;</span>
                                        <span>-</span>
                                        <span>&nbsp;{selectedForEdit && selectedForEdit.destinationLocation ? selectedForEdit.destinationLocation : ""}</span>
                                    </Grid>
                                    <Grid item className={classes.gridParamsDialog} >
                                        <div>{selectedForEdit && selectedForEdit.startDate ? getMilliDatePickerDateInStringDDMMMYYYY(selectedForEdit.startDate) : ""}</div>
                                        <FiberManualRecordIcon className={classes.dotV2} />
                                        <div className={classes.divAlignV2}>
                                            {selectedForEdit && selectedForEdit.truckNumber ?
                                                (
                                                    getVehicleNumberValuesDWeb(selectedForEdit.truckNumber).map((vehicleNumber, index) => (
                                                        <div className={index != 0 ? classes.mlV2 : ""}>
                                                            {vehicleNumber}
                                                        </div>
                                                    ))
                                                )
                                                :
                                                ""}
                                        </div>
                                    </Grid>
                                </Grid>

                                <Grid item className={classes.containerWidth}>
                                    <div className={classes.textBalance}>
                                        {selectedForEdit && selectedForEdit.amounts && selectedForEdit.amounts.balance ? numberFormat(selectedForEdit.amounts.balance) : numberFormat(0)}
                                    </div>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Form
                            onSubmit={onTripEditSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialTripAmountValues}
                            validate={editAmountValidate}
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                tripEditSubmit = handleSubmit; return (
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                            {getAmountFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />

                    </DialogContent>
                    <DialogActions className={classes.dialogActionsV1} >
                        <Button variant="contained" className={classes.closeButton} onClick={handleEditAmountClose} >
                            Close
                        </Button>
                        <Button className={classes.saveButton} variant="contained" onClick={onTripEditSubmit} disabled={dialogConfirmDisabled} classes={{ disabled: classes.saveButtonDisabled }} >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            }

        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchAddPartyPayment: (data, onSuccess, onError) => {
        dispatch(addSinglePartyPayment(data, onSuccess, onError))
    },

});
export default connect(mapStateToProps, mapDispatchToProps)(InvoiceAddPaymentSideBar);